<mat-form-field appearance="outline" class="eiq-search__field">
  <fa-icon matPrefix [icon]="faMagnifyingGlass" [color]="iconColor()"></fa-icon>
  <input
    matInput
    type="text"
    autocomplete="false"
    [value]="currentValue"
    [placeholder]="placeholder()"
    [attr.data-testid]="testId() ? testId() + '-input-search' : null"
    (input)="setValue($event)"
  />
  @if (currentValue?.length > 0) {
    <button matSuffix mat-icon-button class="eiq-button" (click)="clearValue()">
      <fa-icon [icon]="faClose"></fa-icon>
    </button>
  }
</mat-form-field>
